// Per-agency presentation for the CyberFraud Alert pages (10-28 mockups):
// the banner's seal and full name, the alert-type subtitle, and the section
// image that sits between the two text boxes.
//
// Seals are crops from the mockup slides (~180px); swap in vector/hi-res art
// when the agencies' own files are supplied. Section images are the AdobeStock
// files from the brief, resized to 2000px (public/images/alerts).

const AGENCY_PROFILES = {
  ic3: {
    name: 'FBI / Internet Crime Complaint Center (IC3)',
    kind: 'Public Service Announcement',
    seal: '/images/agencies/ic3-seal.png',
    sectionImage: '/images/alerts/ic3-section.jpg',
  },
  ssa: {
    name: 'Social Security Administration',
    kind: 'Consumer Alert',
    seal: '/images/agencies/ssa-seal.png',
    sectionImage: '/images/alerts/ssa-section.jpg',
  },
  irs: {
    name: 'Internal Revenue Service',
    kind: 'Consumer Alert',
    seal: '/images/agencies/irs-seal.png',
    sectionImage: '/images/alerts/irs-section.jpg',
  },
  ftc: {
    name: 'Federal Trade Commission',
    kind: 'Consumer Alert',
    seal: '/images/agencies/ftc-seal.png',
    sectionImage: '/images/alerts/ftc-section.jpg',
  },
};

const FALLBACK = {
  name: 'Consumer Alert',
  kind: 'Consumer Alert',
  seal: null,
  sectionImage: '/images/fraud-alerts/hot-scams/know-more.png',
};

export const agencyProfile = (source) => AGENCY_PROFILES[source] || FALLBACK;

export default AGENCY_PROFILES;
